import { Component, OnInit, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { FooterComponent } from "src/app/shared/components/footer/footer.component";
import { LoadingComponent } from "src/app/shared/components/loader/loading/loading.component";
import { BaseComponent } from "../../base/base.component";
import { HubServiceOrderCheckHistory } from "../../models/hub.model";
import { MenuServiceParameterizationResponse } from "../../models/menu-service.model";
import { OrderCheckStorage } from "../../models/order-check.model";
import { EventService } from "../../services/event.service";
import { HubService } from "../../services/hub.service";
import { OrderCheckService } from "../../services/order-check.service";

@Component({
  selector: "app-layout-app",
  standalone: true,
  imports: [RouterOutlet, FooterComponent, LoadingComponent],
  templateUrl: "./layout-app.component.html",
})
export class LayoutAppComponent extends BaseComponent implements OnInit {
  // Injections
  private hubService = inject(HubService);
  private eventService = inject(EventService);
  public orderCheckService = inject(OrderCheckService);

  // Variables
  orderCheck: OrderCheckStorage = this.orderCheckService.getOrderCheckStorage();
  orderCheckHistory: HubServiceOrderCheckHistory =
    new HubServiceOrderCheckHistory();
  parameterization: MenuServiceParameterizationResponse =
    this.orderCheckService.getParameterization();

  ngOnInit(): void {
    this.onSubscribe();
  }

  //#region Events and synchronization
  onSubscribe() {
    this.subs.push(
      this.hubService.$orderCheckGetted.subscribe(
        (orderCheckHistory: HubServiceOrderCheckHistory) => {
          this.eventService.applyHubOrderCheckHistory(orderCheckHistory);
        },
      ),
    );

    this.subs.push(
      this.eventService.orderCheckHistoryChanged$.subscribe(
        (orderCheckHistory: HubServiceOrderCheckHistory) => {
          this.orderCheckHistory = orderCheckHistory;
        },
      ),
    );
  }
}
